var map = {
	"./403.svg": 278,
	"./404.svg": 279,
	"./410.svg": 280,
	"./500.svg": 281,
	"./Imo.svg": 282,
	"./Viber.svg": 283,
	"./Whatsapp.svg": 284,
	"./brand/logo-white.svg": 285,
	"./brand/logo.svg": 169,
	"./brand/rojgari-white.svg": 194,
	"./covid_stat_1.svg": 243,
	"./covid_stat_2.svg": 244,
	"./covid_stat_3.svg": 245,
	"./misc/en.svg": 286,
	"./misc/failed.svg": 287,
	"./misc/np.svg": 288,
	"./misc/success.svg": 289,
	"./misc/three-dots.svg": 290,
	"./seep.svg": 246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 242;